import { fmt, unixts, parseYYYYMMDD, parseTime, today } from "../../utils/date";

export default {
    
    setMetaString($el, [value/*, meta*/]) {
        $el.val( value != null ? value : '' ); 
    },

    getMetaString($el, [prev, meta]/*, event */) {
        const value = $el.val();
        return [value !== '' ? value : null, meta];
    },

    setMetaBool($el, [value/*, meta*/]) {
        $el[0].checked = value === true;
    },

    getMetaBool($el, [prev, meta]/*, event */) {
        return [$el[0].checked, meta];
    },

    getMetaNumber($el, [prev, meta]/*, event */) {
        const value = $el.val();
        return [value !== '' ? +value : null, meta];
    },

    setMetaDate($el, [value/*, meta*/]) {
        $el.val( value != null ? fmt( value, 'YYYY-MM-DD' ) : '' );
    },

    getMetaDate($el, [prev, meta]/*, event */) {
        const fn = createDateTimeStrToModelConvertor( 
            (value, prev) => parseYYYYMMDD( `${value} ${prev ? fmt( prev, 'HH:mm' ) : '00:00'}:00` ) );

        return [fn( $el.val(), prev ), meta]
    },

    getMetaDateOnlyString($el, [prev, meta]/*, event */) {
        const fn = createDateTimeStrToModelConvertor( 
            (value/*, prev*/) => parseYYYYMMDD( `${value} 00:00:00` ) );

        return [fmt( fn( $el.val(), prev ), 'YYYY-MM-DD' ), meta]
    },

    setMetaTime($el, [value/*, meta*/]) {
        $el.val( value != null ? fmt( value, 'HH:mm' ) : '' );
    },

    getMetaTime($el, [prev, meta]/*, event */) {
        const fn = createDateTimeStrToModelConvertor( 
            (value, prev) => parseYYYYMMDD( `${fmt( prev || today(), 'YYYY-MM-DD' )} ${value}:00` ) );

        return [fn( $el.val(), prev ), meta]
    },

    setMetaDataTableObjects($el, [values, meta]) {
        const tpl = item => 
            `<span class="label label-default --lite" data-id="${item.object_id}">
                <span style="display:inline-block;max-width:200px;overflow:hidden;text-overflow:ellipsis;">${item.title}</span>
                ${item.num != null && meta.amountEditable === 't' ? `<span class="badge">${item.num}</span>` : ''}
            </span>`;

        $el.html( (values || [])
            .sort( (a, b) => a.title < b.title 
                ? -1
                : a.title > b.title 
                    ? 1
                    : a.object_id - b.object_id )
            .map( tpl ).join( ' ' ) ); 
    },

    setMetaFile($el, [files, meta]) {
        // todo pass already calculated attachments here 

        const file = files[meta.index];
        if (!file)
            return;

        const attachment = this.view.model.get( 'attachments' )
            .find( att => 
                file.guid && att.guid === file.guid ||
                file.id   && att.id   === file.id );
        if (!attachment)
            return;

        const type = attachment.type || attachment.file_type;
        const { deleted } = attachment;
        if (deleted === true || deleted === 't')
            $el.addClass( '--deleted' );
        else
            $el.removeClass( '--deleted' );

        const finalize = (bin, attachment) => {
            // original file name is not available immediately after PATCH (bug?)
            const apply = (fileName = '', imageUrl) => {
                if (imageUrl)
                    $el.find( 'img' )[0].src = imageUrl;
                else 
                    $el.find( '.file-instance--extension-mark' )
                        .addClass( '--visible' )
                        .text( fileName.match( /[^\.]+$/ )[0].toUpperCase() /* extension */ );
                $el.closest( '.file-instance' )
                    .find( '.file-instance--filename' )
                    .text( fileName );
            };

            if (bin)
                apply( 
                    bin.name,
                    type === 'PHOTO' && bin.type.startsWith( 'image/' )
                        ? `data: image/jpeg; base64, ${btoa( bin.content )}`
                        : undefined );
            else
                apply( 
                    attachment.file_name,
                    attachment.type === 'PHOTO'
                        ? `/rest/tasks/${attachment.task_id}/photos/${attachment.num}/crop/w128/h128`
                        : undefined );
        };

        if (attachment.reading)
            if (attachment.reading.binaryFile)
                return finalize( attachment.reading.binaryFile );
            else if (attachment.reading instanceof Promise)
                return attachment.reading.then( ({ binaryFile }) => finalize( binaryFile ) );

        finalize( undefined, attachment )
    },

}






function createDateTimeStrToModelConvertor(fn) {
    return (value, prev) => {
        if (!value)
            return null;

        value = fn( value, prev );
        if (!value)
            return null;

        return unixts( value );
    };
}


// WEBPACK FOOTER //
// ./src/js/view/binders/cf.js